import React from "react";

const PendingIcon = () => {
  return (
    <div
  className="size-12 flex items-center justify-center rounded-lg bg-yellow-100 object-cover ring-1 ring-gray-900/10 text-gray-500 text-sm"
  style={{ width: '50px', height: '50px' }} // Adjust size as needed
>
<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-8 h-6 text-yellow-600"
  >
    <path d="M12 2v12M12 18v2" />
  </svg>
</div>

  );
};

export default PendingIcon;
